import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { HYBRID_TABLE_BASE_CLASSNAME } from './Constants';
import { createHybridTable } from './HybridTable';
createComponents(".".concat(HYBRID_TABLE_BASE_CLASSNAME), createHybridTable, NO_PATTERN_BUSINESS_LOGIC);
